import styles from "./InstitutionsTeaching.module.css";
import { useEffect, useState } from "react";
import { apiRequest } from "../../../utils/axiosInstance";
import TeacherCard from "../../TeacherCard/TeacherCard";

const InstitutionsTeaching = () => {
  const [lastJoinedInstitutions, setLastJoinedInstitutions] = useState([])
  useEffect(() => {
    getLastJoinedInstitutions()
  }, [])

  useEffect(() => {
    console.log(lastJoinedInstitutions, "lastJoinedInstitutions")
  }, [lastJoinedInstitutions])

  const getLastJoinedInstitutions = async () => {
    const postData = {
      numberOfOrganizationToShow: 4
    };

    try {
      const data = await apiRequest(`/getLastJoinedInstitutions`, "POST", postData);

      if (!data.error) {
        setLastJoinedInstitutions(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }
  const showLastJoinedInstitutions = () => {

    let lastJoinedInstitutionsToShow = []

    lastJoinedInstitutions.map((single) => {
      lastJoinedInstitutionsToShow.push(
        <>
         {/* <div className={styles.cardContainer}>
          <div className={styles.imgContainer}>
            <img src={single?.officialLogo} alt="person" />
          </div>
          <div className={styles.teacherInfo}>
            <h4>{single?.teachingAccName}</h4>
            <Link href={`${window.location.origin}/t/${single?.subDomain}`}>
              View courses
              <ArrowForwardRoundedIcon fontSize="small" />
            </Link>
          </div>
        </div>  */}
          <TeacherCard
            img={single?.officialLogo}
            name={single?.teachingAccName}
            button={true}
            buttonlebel="View teaching page"
            link={`${window.location.origin}/t/${single?.subDomain}`}
          />
          
        </>
      )
    })
    return lastJoinedInstitutionsToShow
  }
  return (
    <>
      <div
        className={styles.Section}
        style={{
          background: "#fff"
        }}
      >
        <div className={styles.Container}>
          <div className={styles.SectionTitle}>
            Recently joined Takbir
          </div>
          <div className={styles.CardBox}>
            {showLastJoinedInstitutions()}
          </div>
        </div>
      </div>
    </>
  );
};

export default InstitutionsTeaching;
